import ExpandableButton from "@/components/ExpandableButton";
import HBIcon from "@/components/HBIcon";
import { useMemo } from "react";
import styles from "./index.module.less";

export interface SimilarSearchButtonProps {
  /** 采集数据 */
  pin: IPin;
  /** 是否自动展开 */
  autoExpand?: boolean;
  /** 自动展开延迟（ms） */
  autoExpandDelay?: number;
  /** 自动收起延迟（ms） */
  autoCollapseDelay?: number;
  /** 自定义类名 */
  className?: string;
  /** 自定义样式 */
  style?: React.CSSProperties;
  /** 按钮文案 */
  text?: string;
  /** 图标类型 */
  iconType?: string;
  /** 埋点数据（完全由外部控制） */
  trackerData?: Record<string, any>;
}

/**
 * 找相似按钮 - 业务组件
 * 基于 ExpandableButton 封装，添加跳转逻辑
 *
 * 埋点说明：
 * - 内置固定埋点：data-gd-click="button_click", data-button-name="搜索相似采集"
 * - 其他埋点通过 trackerData 传入，如 data-search-word, data-pin-detail 等
 */
export default function SimilarSearchButton({
  pin,
  autoExpand = true,
  autoExpandDelay = 1000,
  autoCollapseDelay = 2000,
  className,
  style,
  text = "找相似",
  iconType = "ic_search-similar1",
  trackerData,
}: SimilarSearchButtonProps) {
  // 生成跳转 URL
  const similarUrl = useMemo(() => {
    if (!pin?.file) return "";
    const params = new URLSearchParams();
    if (pin.file.bucket) params.set("bucket", pin.file.bucket);
    if (pin.file.key) params.set("key", pin.file.key);
    if (pin.file_id) params.set("file_id", String(pin.file_id));
    if (pin.file.width) params.set("width", String(pin.file.width));
    if (pin.file.height) params.set("height", String(pin.file.height));
    return `/similar?${params.toString()}`;
  }, [pin?.file, pin?.file_id]);

  if (!similarUrl) return null;

  return (
    <a
      href={similarUrl}
      target="_blank"
      rel="nofollow"
      className={styles.link}
      data-gd-click="button_click"
      data-button-name="搜索相似采集"
      {...trackerData}
    >
      <ExpandableButton
        autoExpand={autoExpand}
        autoExpandDelay={autoExpandDelay}
        autoCollapseDelay={autoCollapseDelay}
        className={className}
        style={style}
        expandContent={<span className={styles.text}>{text}</span>}
      >
        <HBIcon className={styles.icon} type={iconType} />
      </ExpandableButton>
    </a>
  );
}
